/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownRightIcon24Regular = forwardRef('ArrowDRadiusDownRightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M3.875 5A8.125 8.125 0 0 0 12 13.125h7.367l-5.106-5.106a.875.875 0 0 1 1.237-1.238l5.328 5.327a2.675 2.675 0 0 1 0 3.784l-5.328 5.327a.875.875 0 1 1-1.237-1.238l5.106-5.106H12c-5.454 0-9.875-4.421-9.875-9.875V4a.875.875 0 1 1 1.75 0v1Z" })));
});
